import { TravelDocumentSalesModel } from 'api-hooks/sale/travel-document';

export default function useCheckCompletenessDocument(
  data?: TravelDocumentSalesModel,
) {
  if (!data) return false;
  const documentSales = data.documentSales[0].documentSaleGuests;

  const isComplete = documentSales.every((ds) => {
    if (Array.isArray(ds.details)) {
      return ds.details.every((detail) => {
        return !!detail.files.length;
      });
    } else {
      return !!ds.details.files.length;
    }
  });

  return isComplete;
}
